import styled from 'styled-components';

export const PageWrapStyles = styled.div`
  position: relative;
  width: 100%;
  min-width: 360px;
  max-width: 960px;
  overflow-x: clip;
  background-color: #4a148c;
`;
